import { useTranslations } from '@vocab/react';
import translations from '../.vocab';
import type { BannerProps } from '../HomePageBanner';

// @ts-expect-error
import seekretImage from '../Campaign/Seekret.png';
// @ts-expect-error
import SeekIcon from '../Campaign/SEEK_AYSF.png';
import { selectCountry } from 'src/store/selectors';
import { useSelector } from 'src/store/react';
import type { Country } from '@seek/melways-sites';
import { useMelwaysLink } from '@seek/melways-react';
import { stringify } from 'query-string';

const useSeekretCampaignContent = (): BannerProps => {
  const { t } = useTranslations(translations);
  const location = useSeekretCampaignPath();
  return {
    text: {
      title: t("Better job matches than ever before. It's no myth."),
      subTitle: {
        imageUrl: SeekIcon,
      },
      inverted: true,
    },
    clickable: true,
    location,
    background: {
      color: '#2A0116',
      imageUrl: seekretImage,
    },
  };
};

const useSeekretCampaignPath = () => {
  // in case `country` will be in melways type in future
  const countryStr = useSelector(selectCountry).toUpperCase();
  const path = '/jobmyths';
  const queryParams = stringify({
    tracking: `DAC-ONS-BAN-Candi${countryStr}_WS_SEEKRET-34632`,
    utm_campaign: `Candi${countryStr}_WS_SEEKRET`,
    utm_source: 'Onsite',
    utm_medium: 'Display',
    utm_content: `Candi${countryStr}_WS_SEEKRET_Onsite_DIS_970x250_Homepage_MB_BETTERMATCHES`,
  });

  return useMelwaysLink({
    path: `${path}?${queryParams}`,
    product: 'candidate',
    country: countryStr.toLowerCase() as Country,
  });
};

export default useSeekretCampaignContent;
